import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../../../shared/api/axios-instance';
import { createPathParams } from '../../../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { ReviewStatisticsDto } from '../dtos/review-statistics.dto';
import { ReviewStatisticsModel } from '../models/review-statistics.model';
import { mapReviewStatisticsDtoToReviewStatisticsModel } from '../utils/mapping/mapping.util';

export const getReviewsStats: AsyncThunk<
  ReviewStatisticsModel,
  number,
  Record<string, unknown>
> = withMandant<number, ReviewStatisticsModel>(
  Endpoints.GET_REVIEWS_STATS,
  'reviews/get-reviews-stats',
  async ({ args, endpoint }) => {
    const url = createPathParams<'id'>(endpoint, { id: args });

    const { data }: AxiosResponse<ReviewStatisticsDto> =
      await axiosInstance.get(url);

    return mapReviewStatisticsDtoToReviewStatisticsModel(data);
  }
);
